module.exports = __webpack_public_path__ + "static/media/qr-code.4f3e8e29.png";